module.exports = __webpack_public_path__ + "static/media/2020.7315de1f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/App/images/2020.JPG
// module id = 190
// module chunks = 0